// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1cc3d211","598":"7f04b5a9"}[chunkId] + ".chunk.js";
};